import classNames from 'classnames';

import { useOTSTranslation } from 'i18n/useOTSTranslation';
import { Link } from 'components/blocks/Button';
import { SubscriberDataEvent, useAnalytics } from 'util/analytics';
import { useCallback } from 'react';

import stylesCommon from 'components/common/Grid/Cells/styles.module.scss';
import { IResortPathInfo } from 'api/resort/types';
import styles from './styles.module.scss';

interface IProps {
  url?: string | null,
  resort?: IResortPathInfo,
}

const ToExternalPurchasePageButton = ({ url, resort }: IProps) => {
  const { t } = useOTSTranslation('common');
  const analitic = useAnalytics();

  const onClick = useCallback(() => {
    if (url) {
      analitic.subcriberEvent(SubscriberDataEvent.LiftAccessNavigation, { url, resort });
    }
  }, [analitic, url]);

  if (!url) {
    return null;
  }

  return (
    <Link
      className={classNames(stylesCommon.redirectButton, styles.button)}
      href={url}
      target="_blank"
      onClick={onClick}
    >
      <span>{t('common.purchase')}</span>
    </Link>
  );
};

export default ToExternalPurchasePageButton;
